import { useState, useEffect } from "react";
import { Modal } from "../Modal/Modal";
import { Button } from "../Button/Button";
import MultiPeoplePicker from "../peoplePicker/MultiPeoplePicker";
import useADUsers from "../../../hooks/useADUsers";
import { useI18n } from "../../../hooks/useI18n";
import "./AssignEngagementManagerModal.scss";

function ModalHeader({ t }) {
  return (
    <span className="assign-em-modal-title">{t("modal_assignEM")}</span>
  );
}

function ModalBody({ selectedUser, onChange, error, t, getADUsers, note }) {
  return (
    <div className="assign-em-modal-body">
      {note && (
        <div className="assign-em-modal-note" role="note">
          <svg
            className="assign-em-modal-note-icon"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            aria-hidden="true"
          >
            <path
              fill="currentColor"
              fillRule="evenodd"
              d="M8 1.333a6.667 6.667 0 1 0 0 13.334A6.667 6.667 0 0 0 8 1.333ZM2.667 8a5.333 5.333 0 1 1 10.666 0A5.333 5.333 0 0 1 2.667 8Zm5.333-.667a.667.667 0 0 1 .667.667v2.667a.667.667 0 0 1-1.334 0V8A.667.667 0 0 1 8 7.333Zm0-2a.667.667 0 1 0 0 1.334.667.667 0 0 0 0-1.334Z"
              clipRule="evenodd"
            />
          </svg>
          <span>{note}</span>
        </div>
      )}
      <MultiPeoplePicker
        getADUsers={getADUsers}
        onChange={onChange}
        options={[]}
        disabledPicker={false}
        value={selectedUser}
        isErrorVisible={false}
        errorMessage=""
        isErrorVisible2={false}
        errorMessage2=""
        placeholder={t("modal_typeHere")}
        pageName="Assign EM"
      />
      {error && (
        <span className="assign-em-modal-error">{error}</span>
      )}
    </div>
  );
}

function ModalFooter({ onCancel, onAssign, disabled, loading, t }) {
  return (
    <div className="assign-em-modal-footer">
      <Button variant="secondary" onClick={onCancel} disabled={loading}>
        {t("cancel")}
      </Button>
      <Button
        variant="primary"
        onClick={onAssign}
        disabled={disabled || loading}
      >
        {loading ? t("modal_assigning") : t("modal_assign")}
      </Button>
    </div>
  );
}

export function AssignEngagementManagerModal({
  show,
  onClose,
  onAssign,
  loading = false,
  error = "",
  onClearError,
  note,
}) {
  const { t } = useI18n();
  const { getADUsers } = useADUsers();
  const [selectedUser, setSelectedUser] = useState(null);

  useEffect(() => {
    if (!show) {
      setSelectedUser(null);
      if (onClearError) onClearError();
    }
  }, [show]);

  const handleChange = (option) => {
    setSelectedUser(option || null);
    if (error && onClearError) onClearError();
  };

  const handleAssign = () => {
    if (selectedUser?.label) {
      onAssign({
        email: selectedUser.label,
        firstName: selectedUser.firstName || "",
        lastName: selectedUser.lastName || "",
      });
    }
  };

  const handleClose = () => {
    if (loading) return;
    setSelectedUser(null);
    if (error && onClearError) onClearError();
    onClose();
  };

  return (
    <Modal
      show={show}
      onClose={handleClose}
      className="assign-em-modal"
      size="sm"
      header={<ModalHeader t={t} />}
      body={
        <ModalBody
          selectedUser={selectedUser}
          onChange={handleChange}
          error={error}
          t={t}
          getADUsers={getADUsers}
          note={note}
        />
      }
      footer={
        <ModalFooter
          onCancel={handleClose}
          onAssign={handleAssign}
          disabled={!selectedUser?.label}
          loading={loading}
          t={t}
        />
      }
    />
  );
}
